let loadedPixelIds = [];

const logEvent = (type, payload) => {
    
        console.log(`📡 [Facebook Pixel] ${type}`, payload);
    
};

const initPixel = (pixelIds = []) => {
    console.log("❌ fbq");
    if (!window.fbq) return;
    console.log("❌ after fbq");
    // Ne réinitialise pas si déjà chargé
    pixelIds.forEach((id) => {
        if (!loadedPixelIds.includes(id)) {
            window.fbq('init', id);
            loadedPixelIds.push(id);
            logEvent('init', { pixelId: id });
        }
    });

    window.fbq('track', 'PageView');
    logEvent('track', { event: 'PageView', pixelIds });
};

const track = (eventName, params = {}) => {
    if (!window.fbq) return;

    loadedPixelIds.forEach((id) => {
        window.fbq('trackSingle', id, eventName, params);
        logEvent('trackSingle', { pixelId: id, event: eventName, params });
    });
};

export default {
    initPixel,
    track,
};